import{spacing as a}from"./spacing.js";var i={padding:a.S,margin:{active:"-2px",inactive:"-1px"}};export{i as default};
